import { isAgentHubEnabled } from 'agentHub/selectors/agentHubSelectors'
import config from 'constants/config'
import { useAppSelector } from 'hooks/reduxHooks'
import { LUX_PLUS_GIFT_CARD_CAMPAIGN } from 'luxPlus/constants/base'

const MALDIVES_BANNER_END_DATE_MS = new Date('2026-02-17T00:00:00+11:00').getTime()

const MALDIVES_BANNER_BRANDS: Array<App.BrandName> = [
  'luxuryescapes',
  'leagenthub',
  'leagenthub_cvfr',
]

/**
 * Hook to determine if the Maldives Charter banner should be shown.
 * Shows for AU users until campaign end date.
 * Hidden when the LuxPlus gift card campaign is active.
 */
export function useShowMaldivesBanner(): boolean {
  const currentRegionCode = useAppSelector(state => state.geo.currentRegionCode)
  const { SHOULD_OVERRIDE_MALDIVES_CAMPAIGN } = LUX_PLUS_GIFT_CARD_CAMPAIGN
  const isBrandSupported = MALDIVES_BANNER_BRANDS.includes(config.BRAND)
  const isRegionSupported = currentRegionCode === 'AU'
  return isBrandSupported && isRegionSupported && Date.now() < MALDIVES_BANNER_END_DATE_MS && !isAgentHubEnabled && !SHOULD_OVERRIDE_MALDIVES_CAMPAIGN
}
